export default {
  token: '',
  activeUser: {},
  prevAuthPage: undefined,
  user:[],
  userID: '',
  loginOtp:[]
}
